import React, { useEffect, useState } from 'react'
import { DataGrid } from '@mui/x-data-grid';
import Axios from 'axios';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { Paper } from "@mui/material";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import { urlConfig } from "../config"; 


const CreateTab = ({handleSuccess,handleError,handleCreateButtonClose}) => {
    const [tabList,setTabList]=useState([])
    const [create,setCreate] = useState(false)
    const[tabName,setTabName]=useState('')
    const[tabId,setTabId]=useState('')
    const [deleteRecord,setDeleteRecord]=useState({})
    const[confirmDelete,setConfirmDelete]=useState(false)
    const[confirmCreate,setConfirmCreate]=useState(false)
    const [userEmail,setUserEmail]=useState('');

    const columns = [
        { field: 'tabId', headerName: 'Tab ID', width: 70, headerAlign: 'center', align: 'center'  }, 
        { field: 'tabName', headerName: 'Tab Name', width: 250, },
        { 
            field: "Delete",
      headerName: "Delete",
      headerAlign: 'center',
      width: 90,
      renderCell: (params) => {
        return (
          <Button
            onClick={() => deleteButton(params.row)}
          >
            Delete
          </Button>
        );
      }
        },
    ]

    useEffect(()=>{
        setUserEmail(sessionStorage.getItem("userEmail"));
        Axios.get(`${urlConfig.cmsURL}/api/tabs/getallTabs`)
        .then((res)=>{
            setTabList(res.data)
        })
     
    },[])

    function deleteButton  (params)  { 
        setDeleteRecord(params);
        setConfirmDelete(true);
        }

        const handleDelete = (e) => {
            e.preventDefault();
            Axios.delete(`${urlConfig.cmsURL}/api/tabs/deleteTabs/${deleteRecord.id}?email=${userEmail}`)
            .then((res)=>{
                handleSuccess(res.data.message)
               
            })
            .catch((err)=>{
                handleError("Facing error")
            })
            setConfirmDelete(false)
        }
        
 
    const handleCreate = () => {
        Axios.post(`${urlConfig.cmsURL}/api/tabs/addTabs?email=${userEmail}`,
        {
            tabId:tabId,
            tabName:tabName
        })
        .then((res)=>{
            handleSuccess(res.data.message)
            setTabName('')
            setTabId('')
        })
        .catch((err)=>{
            handleError("Facing error")
        })
      setConfirmCreate(false)
    }


  return (
    <>
      
        <Stack sx={{ ml:3,mt:2 }} direction='row' spacing={2}>
             <Button variant="outlined" onClick={handleCreateButtonClose} >
       Go to home
    </Button>
        <Button variant="outlined" onClick={()=>setCreate(true)} >
       Add new tab
    </Button>
        </Stack>

       
    <Dialog open={confirmDelete}>
        <DialogTitle>Are you sure.You want to delete it?</DialogTitle>
        <DialogActions>
            <Button onClick={handleDelete}>Confirm</Button>
            <Button onClick={()=>setConfirmDelete(false)}>Cancel</Button>
        </DialogActions>
    </Dialog>

    <Dialog open={confirmCreate}>
        <DialogTitle>Are you sure.You want to create it?</DialogTitle>
        <DialogActions>
            <Button onClick={handleCreate}>Confirm</Button>
            <Button onClick={()=>setConfirmCreate(false)}>Cancel</Button>
        </DialogActions>
    </Dialog>

{create && <div>
    <Box
    sx={{
        '& > :not(style)': { m: 1 },
      }}>
    <TextField sx={{ width: 300 }} onChange={(e)=>{setTabId(e.target.value)}}  label="Tab Id" value={tabId} required />
    <TextField sx={{ width: 300 }} onChange={(e)=>{setTabName(e.target.value)}}  label="Tab Name" value={tabName} required />
    <Button variant="outlined" onClick={()=>setConfirmCreate(true)} >Create</Button>
    <Button variant="outlined" onClick={()=>setCreate(false)} >Cancel</Button>
    </Box>
   
    </div>}
    <Paper sx={{ height: 450, width: '100%',ml:3,mt:2, p:3 }}>
      <DataGrid
        rows={tabList}
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[10]}    
      />
    </Paper>
    </>
  )
}

export default CreateTab